import { alpha } from "@mui/material/styles";

/**
 * Look of the react-day-picker calendars (date filters, date pickers).
 * `compact` shrinks the cells for small viewports; `singleMonth` tightens the gap.
 */
export const getDayPickerSx = (theme, { compact = false, singleMonth = false } = {}) => {
  return {
    "& .rdp": {
      margin: 0,
      "--rdp-cell-size": compact ? "30px" : "32px",
      "--rdp-caption-font-size": compact ? "13px" : "14px",
      "--rdp-accent-color": theme.palette.primary.main,
      "--rdp-background-color": alpha(theme.palette.primary.main, 0.12),
    },
    "& .rdp-months": {
      justifyContent: "center",
      gap: singleMonth ? 0.35 : "1.5rem",
    },
    "& .rdp-month": {
      margin: 0,
    },
    "& .rdp-caption": {
      marginBottom: 0.3,
    },
    "& .rdp-caption_label": {
      fontSize: "0.82rem",
      fontWeight: 600,
    },
    "& .rdp-nav_button": {
      width: compact ? "24px" : "26px",
      height: compact ? "24px" : "26px",
    },
    "& .rdp-head_cell": {
      width: compact ? "30px" : "32px",
      height: "22px",
      fontSize: "0.6rem",
      fontWeight: 600,
      color: theme.palette.text.secondary,
    },
    "& .rdp-cell": {
      textAlign: "center",
      padding: 0,
    },
    "& .rdp-button_reset, & .rdp-button": {
      width: "100%",
      height: compact ? "26px" : "28px",
      borderRadius: "0",
      fontSize: "0.74rem",
      border: "none",
      boxShadow: "none",
    },
    "& .rdp-button": {
      color: theme.palette.text.primary,
      backgroundColor: "transparent",
    },
    "& .rdp-button.rdp-day_selected": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderRadius: "6px",
    },
    "& .rdp-button.rdp-day_range_middle": {
      backgroundColor: alpha(theme.palette.primary.main, 0.14),
      borderRadius: 0,
      color: `${theme.palette.text.primary} !important`,
    },
    "& .rdp-button.rdp-day_range_start, & .rdp-button.rdp-day_range_end":
      {
        backgroundColor: theme.palette.primary.main,
        color: `${theme.palette.primary.contrastText} !important`,
      },
    "& .rdp-button.rdp-day_range_start:not(.rdp-day_range_end)": {
      borderRadius: "6px 0 0 6px",
    },
    "& .rdp-button.rdp-day_range_end:not(.rdp-day_range_start)": {
      borderRadius: "0 6px 6px 0",
    },
    "& .rdp-button.rdp-day_range_start.rdp-day_range_end": {
      borderRadius: "6px",
    },
    "& .rdp-button:hover:not([disabled]):not(.rdp-day_selected):not(.rdp-day_range_start):not(.rdp-day_range_end):not(.rdp-day_range_middle)":
      {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
      },
    "& .rdp-button.rdp-day_range_middle:hover:not([disabled])": {
      backgroundColor: alpha(theme.palette.primary.main, 0.2),
    },
    "& .rdp-button:focus-visible": {
      outline: `2px solid ${alpha(theme.palette.primary.main, 0.35)}`,
      outlineOffset: "1px",
    },
  };
};
